import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CardsImg from '../../../assets/cards.svg';

import { TXTWCL_No_Games_to_Show } from './NoGamesAvailable.messages.json';
import styles from './NoGamesAvailable.scss';

// TODO: Add translation when available https://jira.pyrsoftware.ca/jira/browse/LMS-18911
const registeredAndActiveGamesTranslation = {
  id: 'registeredAndActiveGamesTranslation',
  defaultMessage: 'Your registered and active games will be displayed here'
};

const NoGamesAvailable: React.FC = () => (
  <div className={styles.wrap}>
    <CardsImg />
    <p className={styles.title}>
      <Translation {...TXTWCL_No_Games_to_Show} />
    </p>
    <p className={styles.description}>
      <Translation {...registeredAndActiveGamesTranslation} />
    </p>
  </div>
);

export default NoGamesAvailable;
